import { render, staticRenderFns } from "./main.vue?vue&type=template&id=78a245ec&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=78a245ec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a245ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78a245ec')) {
      api.createRecord('78a245ec', component.options)
    } else {
      api.reload('78a245ec', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=78a245ec&scoped=true", function () {
      api.rerender('78a245ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Campaign/InformationBasic/components/ModalScopeOrder/main.vue"
export default component.exports